import { Box } from '@dixa/lib-shared-habla';
import { PropsWithChildren, PropsWithClassName } from 'lib-shared-types-utils';

interface ToggleBoxBodyProps extends PropsWithClassName, PropsWithChildren {}

export function ToggleBoxBody({
  children,
  className,
}: ToggleBoxBodyProps): JSX.Element | null {
  return (
    <Box padding="0 300 300" className={className}>
      {children}
    </Box>
  );
}
